import ajax from './http'

//文件上传
export function uploadFile(formData, onUploadProgress) {
  return ajax({
    url: "/upload/mulipart/pm",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
    data: formData
  })
}
//文件上传 敏感信息，上传私有云
export function uploadFilePr(formData, onUploadProgress) {
  return ajax({
    url: "/upload/mulipart/pr",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
    data: formData
  })
}
//视频上传
export function uploadVideoFile(formData, onUploadProgress) {
  return ajax({
    type: "POST",
    url: "/upload/uploadProductVideo",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
    data: formData
  })
}
// 获取机构信息
export function getOrganizationInfo(data) {
  return ajax({
    type: "POST",
    contentType: "from",
    url: `/buz/organizationBase/getInfo`,
    data
  })
}

//保单 列表
export function getInsureOrderList(data) {
  return ajax({
    url: "/buz/policy/read/list",
    type: "POST",
    data
  })
}